import { useSelector } from "react-redux";
import { State } from "../../../../reducers";
import DocumentoTributarioV1 from "./contents/DocumentoTributarioV1";
import NotaCreditoDetalle from "./contents/NotaCreditoDetalle";


const RenderDoc = (props: any) => {
  switch (props.idDoc) {
    case '05':
      return <NotaCreditoDetalle />;
    default:
      return <DocumentoTributarioV1/>;
  }
};

const DynamicDetalleContent = () => {
  const {activeDoc} = useSelector((state: State) => state.documentos)
  return (
    <RenderDoc idDoc={activeDoc.idDoc} />
  )
}

export default DynamicDetalleContent;